import { imageUrl } from '@helpers/image';
import { withMotionMax } from '@hoc/withMotionMax';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import S from './NavigationMobile.styles';
const NavigationMobile = ({ activeId, sageHomeCta, items = [], onItemClick, rentalHomeCta, }) => {
    const flattened = flatMapRecursive(items, (item) => item.children ?? []);
    const activeItem = flattened.find((item) => item.id === activeId);
    const activeItemChildren = activeItem?.children;
    const activeItemSelected = activeItem?.selected;
    const activeItemParent = flattened.find((item) => item.children?.find((child) => child.id === activeId));
    return (React.createElement(AnimatePresence, null,
        React.createElement(S.Container, { key: activeItem?.id ?? '0', initial: 'hidden', animate: 'visible', exit: 'hidden', variants: {
                hidden: {
                    position: 'absolute',
                    opacity: 0,
                    width: '100%',
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
                visible: {
                    position: 'relative',
                    opacity: 1,
                    visibility: 'visible',
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
            } },
            activeItem && (React.createElement(React.Fragment, null,
                React.createElement(S.BackButton, { onClick: (event) => {
                        event.preventDefault();
                        onItemClick(activeItemParent?.id ?? '');
                    } },
                    React.createElement(S.BackArrow, null),
                    activeItemParent?.text ? `Back to ${activeItemParent?.text}` : 'Back'),
                React.createElement(S.Title, { href: activeItem.url }, activeItem.text))),
            React.createElement(S.LinkHolder, null, (activeItemChildren
                ? activeItemChildren
                : activeItemSelected
                    ? activeItemSelected
                    : items).map((item) => (React.createElement(S.Item, { key: item.id, hasImage: item.bgImage ? true : false, dropDownType: activeItem?.dropdown, isChild: activeId === '' }, item.children?.length || item.selected?.length ? (React.createElement(S.ItemButton, { onClick: (event) => {
                    event.preventDefault();
                    onItemClick(item.id);
                } },
                item.text,
                item.description && React.createElement(S.LinkDescription, null, item.description),
                React.createElement(S.ItemArrow, null))) : (React.createElement(S.ItemLink, { href: item.url },
                item.bgImage && (React.createElement(S.BgImageHolder, null,
                    React.createElement(S.BgImage, { alt: '', draggable: false, loading: "lazy", role: "presentation", src: imageUrl(item.bgImage, {}), sizes: [`50vw`].join(', '), srcSet: [`${imageUrl(item.bgImage, { width: 789 })} 789w`].join(', ') }))),
                React.createElement(S.ContentHolder, null,
                    item.text,
                    item.description && React.createElement(S.LinkDescription, null, item.description),
                    item.external && React.createElement(S.External, null)))))))),
            React.createElement(S.NavBase, null,
                React.createElement(S.NavCtaHolder, null,
                    sageHomeCta && sageHomeCta?.url && (React.createElement(S.CtaBtn, { branding: 'secondary', title: sageHomeCta.text ?? '', href: sageHomeCta?.url, target: sageHomeCta?.target })),
                    rentalHomeCta && rentalHomeCta?.url && (React.createElement(S.CtaBtn, { branding: 'secondary', title: rentalHomeCta?.text ?? '', href: rentalHomeCta?.url, target: rentalHomeCta?.target })))))));
};
export default withMotionMax(NavigationMobile);
function flatMapRecursive(array, iteratee) {
    let result = [];
    array.forEach((item) => {
        result = result.concat(item);
        if (Array.isArray(iteratee(item))) {
            result = result.concat(flatMapRecursive(iteratee(item), iteratee));
        }
    });
    return result;
}
